<template>
  <div class="page-content prose">
    <div class="container">
      <div class="flex justify-center pb-8">
        <ContentInfoLinks />
      </div>

      <h1>2toDrive</h1>
      <p>
        In november 2011 is het project 2toDrive van start gegaan. Dankzij
        2toDrive kun je al vanaf 16,5 jaar beginnen met je rijlessen en
        rijexamen doen op je zeventiende. Tot je achttiende verjaardag mag je
        alleen nog onder begeleiding achter het stuur, maar vanaf de dag dat je
        achttien bent kun je zelfstandig de weg op. Het doel van 2toDrive, een
        project naar Duits voorbeeld, is om jonge chauffeurs eerst geleidelijk
        ervaring op te laten doen aan de hand van een begeleider om op die
        manier het aantal ongelukken en boetes onder jongeren te laten afnemen.
      </p>

      <h2>2toDrive: de regels</h2>
      <p>Wat zijn de regels van 2toDrive precies?</p>
      <ul>
        <li>Als je 16 jaar bent, mag je je theorie-examen al afleggen.</li>
        <li>
          Vanaf 16,5 jaar kun je beginnen met je rijlessen bij een rijschool.
        </li>
        <li>Op je zeventiende mag je praktijkexamen doen.</li>
        <li>
          Als je geslaagd bent voor zowel je theorie- als je praktijkexamen, mag
          je volgens de regels van 2toDrive tot je achttiende onder begeleiding
          autorijden.
        </li>
        <li>Vanaf je achttiende mag je <i>zonder</i> begeleiding de weg op.</li>
      </ul>
      <p>
        Het mooie van 2toDrive is dat je beter en langer wordt voorbereid op het
        moment dat je zelfstandig de weg op gaat, maar toch eerder je rijbewijs
        kunt behalen. Je kiest bovendien zelf je begeleider(s).
      </p>

      <h2>Rijschool zoeken?</h2>
      <p>
        Ben je jonger dan achttien en wil je graag beginnen met je rijlessen?
        2toDrive biedt je die mogelijkheid! Daarnaast kun je op
        Rijscholenvergelijker.nl terecht voor de beste
        <nuxt-link to="/"> rijscholen </nuxt-link>in je eigen omgeving. Of je nu
        een
        <nuxt-link to="/informatie-over-rijscholen/amsterdam">
          rijschool in Amsterdam </nuxt-link
        >zoekt of op zoek bent naar een
        <nuxt-link to="/informatie-over-rijscholen/groningen">
          rijschool in Groningen </nuxt-link
        >en omstreken: wij zorgen ervoor dat de rijscholen in jouw regio de
        volgende dag al contact opnemen als je je gegevens achterlaat op de
        website. Kies voor de beste rijschool en doe mee aan 2toDrive!
      </p>
    </div>
  </div>
</template>

<script>
import AbstractPage from 'chimera/all/components/page/AbstractPage'
import ContentInfoLinks from '~/components/layout/ContentInfoLinks'

export default {
  components: {
    ContentInfoLinks,
  },

  extends: AbstractPage,

  layout: 'content',

  /**
   * @returns {object}
   */
  data() {
    return {
      headTitle: '2toDrive: kijk voor informatie op Rijscholenvergelijker.nl!',
      headDescription:
        'Heb je weleens van 2toDrive gehoord, maar weet je niet precies wat het inhoudt? Lees alles over 2toDrive op Rijscholenvergelijker.nl!',
    }
  },
}
</script>
